import React from "react";
import image1 from "../../assets/image1.png";
import image2 from "../../assets/image2.png";
import image3 from "../../assets/image3.png";
import image4 from "../../assets/image4.png";
import nb from "../../assets/nb.png";
import adidas from "../../assets/adidas.png";
import nike from "../../assets/nike.png";
import tick from "../../assets/tick.png";
import "./Reasons.css";

const Reasons = () => {
  return (
    <div className="Reasons" id="reasons">
      <div className="left_reasons">
        <img src={image1} alt="" />
        <img src={image2} alt="" />
        <img src={image3} alt="" />
        <img src={image4} alt="" />
      </div>
      <div className="right_reasons">
        <span>Some Reasons to chose us</span>
        <div>
          <span className="stroke-text">WHY </span>
          <span className="question"> Chose US ?</span>
        </div>
        <div className="details-reasons">
          <div>
            <img src={tick} alt="" />
            <span>Over 140+ Extra Coatches</span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>train smarter and faster  than before </span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>1 free program for new member</span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span> for reliable partners</span>
          </div>
        </div>
        <span className="PartNers">
          Our Partners
        </span>
        <div className="Partners">
          <img src={nb}></img>
          <img src={adidas}></img>
          <img src={nike}></img>
        </div>
      </div>
    </div>
  );
};

export default Reasons;
